/**
 * This file is part of ONP.
 *
 * Copyright (c) 2014 Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Andrey Tkachenko <andrey.tkachenko@opensoftdev.ru>
 */

define(['jquery', 'assets/js/modules/utils'], function($, utils) {
    return {
        supportFile: function() {
            return $('<input type="file">').get(0).files !== undefined;
        },

        supportFileReader: function() {
            return !!window.FileReader;
        },

        supportReadAsBinaryString: function() {
            if (this.supportFileReader()) {
                var fileReader = new FileReader();
                return !!fileReader.readAsBinaryString;
            }
            return false;
        },

        supportHtml5Uploader: function() {
            return window.File && window.FileList && window.FileReader;
        },

        supportWebWorkers: function() {
            return !!window.Worker;
        },

        supportFileApi: function() {
            return !!(window.File && window.FileReader && window.FileList && window.Blob);
        },

        hasWebGL: function() {
            var canvas = document.createElement('canvas'),
                gl;
            try {
                gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
            } catch (e) {}

            return !gl == false;
        },

        getParameters: function() {
            var parts = window.location.search.substring(1).split('&');
            var params = {};

            for (var i = 0, el; i < parts.length; i++) {
                el = parts[i].split('=');
                params[el[0]] = decodeURIComponent(el[1]).replace('+', ' ');
            }

            return params;
        },

        isChrome: function() {
            return !!window.chrome && !this.isOpera();
        },

        isOpera: function() {
            return !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
        },

        isMobile: function() {
            return (
                window.orientation !== undefined ||
                navigator.userAgent.indexOf('IEMobile') !== -1 ||
                /Mobile|mobile/i.test(navigator.userAgent)
            );
        },

        isIE: function() {
            return navigator.appName.substring(0, 9) == 'Microsoft';
        },

        getIEMajorVersion: function() {
            var matchIE = /MSIE\s([\d.]+)/;
            var matches = navigator.userAgent.match(matchIE);
            if (matches !== null) {
                return matches[1].substring(0, matches[1].indexOf('.'));
            }

            return false;
        },

        isFirefox: function() {
            return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        },

        isOldFirefox: function() {
            var nAgt = navigator.userAgent;
            var verOffset;
            if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
                var fullVersion = nAgt.substring(verOffset + 8);
                var majorVersion = parseInt('' + fullVersion, 10);
                if (!isNaN(majorVersion) && majorVersion < 31) {
                    return true;
                }
            }

            return false;
        },

        isNotSupported: function() {
            var ieVersionsNotSupported = [7, 8, 9, 10];

            if (
                (this.getIEMajorVersion() && ieVersionsNotSupported.indexOf(this.getIEMajorVersion())) ||
                this.isSafari5() ||
                this.isSafari6() ||
                this.isOldFirefox()
            ) {
                return true;
            }

            return false;
        },

        isSafari: function() {
            return !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
        },

        isSafari5: function() {
            return (
                !!navigator.userAgent.match(' Safari/') &&
                !navigator.userAgent.match(' Chrom') &&
                !!navigator.userAgent.match(' Version/5.')
            );
        },

        isSafari6: function() {
            return (
                !!navigator.userAgent.match(' Safari/') &&
                !navigator.userAgent.match(' Chrom') &&
                !!navigator.userAgent.match(' Version/6.')
            );
        },

        getUrlVars: function() {
            var vars = [],
                hash;
            if (window.location.href.indexOf('?') > 0) {
                var hashes = window.location.href
                    .slice(window.location.href.indexOf('?') + 1)
                    .split('#')[0]
                    .split('&');
            } else {
                return vars;
            }
            for (var i = 0; i < hashes.length; i++) {
                hash = hashes[i].split('=');
                vars[hash[0]] = hash[1];
            }

            return vars;
        },

        getUrlHashes: function() {
            var uri = window.location.href;
            var hashes = [];
            if (uri.indexOf('#') === -1) {
                return hashes;
            }

            uri = uri.slice(uri.indexOf('#') + 1);
            var particles = uri.split('&');
            for (var i = 0; i < particles.length; i++) {
                hash = particles[i].split('=');
                hashes[hash[0]] = hash[1];
            }

            return hashes;
        },

        browserHasCredentials: function() {
            if (navigator.credentials === undefined) {
                return false;
            }

            // if there is no parameters for login or user already logged, we must skip auto sign-in
            if (ONP.user.loggedIn !== false || !ONP.loginUrl) {
                return false;
            }

            return true;
        },

        tryAutoSignIn: function(callback, fallback) {
            var onSuccess = callback || null;
            var onFallback = fallback || null;
            if (this.browserHasCredentials()) {
                utils.sendPreparedCredentials(this.autoSignIn, onSuccess, onFallback);
            } else if (onFallback) {
                onFallback();
            }
        },

        autoSignIn: function(callback, credentials) {
            $.post(ONP.loginUrl, credentials, null, 'json').always(function() {
                if (callback) {
                    callback();
                }
            });
        },

        tryAutoSignOut: function() {
            if (this.browserHasCredentials()) {
                try {
                    navigator.credentials.preventSilentAccess();
                } catch (err) {
                    //in case not supported
                }
            }
        },

        refreshPage: function() {
            location.reload(true);
        }
    };
});
